/* istanbul ignore file */
/* eslint-disable */
export const environment: {
envName: string;
kushkiUrl: string;
etpayFunnelUrl: string;
fallbackRedirectUrl: string;
devTools: boolean;
} = {
envName: "",
kushkiUrl: "https://api-qa.orizaba.kushki.dev",
etpayFunnelUrl: "https://funnel.etpay.com",
fallbackRedirectUrl: "",
devTools: false
};
